import PropTypes from 'prop-types';
import React from 'react';
import SlideItem from './slide-item';

const LogoSlides = ({items, index, numSlides}) => {
  const slides = items.map((item, i) => <SlideItem item={item} index={i} key={i}/>);

  return (
    <div role="group" aria-label={`slide ${index+1} of ${numSlides}`}>
      {slides}
    </div>
  );
};

LogoSlides.propTypes = {
  items: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired
};

export default LogoSlides;



// WEBPACK FOOTER //
// ./src/components/homepage/press/logo-slides.js